import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
// Parité V1 : BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }) supprimé —
// withServerTransition n'existe plus en Angular 21 et BrowserModule ne doit être importé
// que par le module racine. CommonModule fournit les directives (ngIf, ngFor…) utilisées ici.
import { CommonModule } from '@angular/common';
// Parité V1 : ClickOutsideModule provenait de 'ng-click-outside' (non installé en V2) —
// remplacé par le module vendored local, même API (clickOutside) + [delayClickOutsideInit].
import { ClickOutsideModule } from '@shared/vendored/click-outside';
import { RouterModule } from '@angular/router';
import { NavMenuComponent, SideMenuComponent, AccountMenuComponent} from './index';
import { AppCommonModule } from '@modules/common/app-common.module';
import { TableModule } from 'primeng/table';
import {CheckboxModule} from 'primeng/checkbox';
import { SettingMenuComponent } from './setting-menu/setting-menu.component';
import { NavMenuAnonymousComponent } from './nav-menu-anonymous/nav-menu-anonymous.component';
// Parité V1 : import depuis 'primeng/primeng' interdit en v21 → import individuel.
import { TooltipModule } from 'primeng/tooltip';

// NOTE portage : le fichier V1 side-menu/side-menu.component.html est un orphelin JAMAIS compilé
// (SideMenuComponent référence side-menu-v2.component.html) — il n'a volontairement pas été porté.

@NgModule({
  declarations: [
    NavMenuComponent,
    SideMenuComponent,
    AccountMenuComponent,
    SettingMenuComponent, NavMenuAnonymousComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ClickOutsideModule,
    AppCommonModule,
    TableModule,
    CheckboxModule,
    FormsModule,
    ProgressSpinnerModule,
    TooltipModule
  ],
  providers: [
  ],
  exports: [NavMenuComponent,NavMenuAnonymousComponent]
})
export class NavMenuModule { }
